/**
 * External dependencies
 */

import isEmpty from 'lodash/isEmpty';

/**
 * DWT dependencies
 */

import ConditionalWrapper from '../../components/ConditionalWrapper';

/**
 * WP dependencies
 */

import { useBlockProps } from '@wordpress/block-editor';

const save = ({ attributes }) => {
  const {
    imageSelection,
    apiImage,
    coverAltText,
    uploadedImage,
    isbn,
    bookTitle,
    author,
    workId,
    url,
    linkTarget
  } = attributes;

  const blockProps = useBlockProps.save({
    className: 'block__book-cover flex justify-center'
  });

  const isEmptyImage = isEmpty( uploadedImage );

  /**
    * Handle additional logic
    */

  const apiImageAltText = ( coverAltText === undefined ) || ( coverAltText === '' ) ? ( `${bookTitle} by ${author} ` ).trim() : coverAltText;

  const imageClasses = !isEmptyImage ? 'shadow-book-img uploaded-image' : 'shadow-book-img api-image';
  const imageSrc = !isEmptyImage ? uploadedImage?.sizes?.full.url : apiImage;
  const imageAltText = !isEmptyImage ? uploadedImage.alt : apiImageAltText;

  return (
    imageSrc && (
      <div { ...blockProps }>
        <div className='book-cover--inner'>
          <div className="image-wrapper relative">
            <ConditionalWrapper
              condition={ url }
              // eslint-disable-next-line react/jsx-no-target-blank
              wrapper={ ( img ) => <a href={ url } target={ linkTarget ? '_blank' : null } rel={ linkTarget ? 'noopener' : null }>{ img }</a> }
            >
              <img
                className={ imageClasses }
                src={ imageSrc }
                alt={ imageAltText }
                title={ bookTitle || null }
                data-isbn={ isbn || null }
                data-workId={ workId || null }
                loading='lazy'
              />
            </ConditionalWrapper>
          </div>
        </div>
      </div>
    )
  );
};

export default save;
